module.exports = __webpack_public_path__ + "static/media/nominal_zoom.36f811e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nominal_zoom.png
// module id = 87
// module chunks = 0